import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from "@angular/common/http";

/*------------------ user created components...  --------------------------------*/
import { BaseService } from './BaseService';
import { IFormNotes } from "../Models/Forms/IFormNotes";

@Injectable()
export class FormNotesService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormNotes(id: number) {
    return this._http.get(this._baseUrl + "api/FormNotes/" + id)
      .map((response: IFormNotes) => response as IFormNotes)
      .catch(this.errorHandler);
  }

  insertUpdateFormNotes(formNotesDetails: IFormNotes) {
    return this._http.post(this._baseUrl + 'api/FormNotes', formNotesDetails)
      .map((response: IFormNotes) => response as IFormNotes)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormNotes/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteAgeOfMajority18(id) {
    return this._http.delete(this._baseUrl + "api/FormNotes" + id)
      .map((response: IFormNotes) => response as IFormNotes)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}



